import React from 'react';

import {
    ORDERS_PAGE_SIZE_OPTIONS,
    getTablePageNumbers,
} from './ordersTablePaginationUtils';
import './css/OrdersTablePagination.css';

function OrdersTablePagination({
    currentPage,
    totalPages,
    totalItems,
    pageSize,
    onPageChange,
    onPageSizeChange,
    itemLabel = 'orders',
    ariaLabel = 'Table pagination',
}) {
    if (totalItems <= 0) return null;

    const safeTotalPages = Math.max(1, totalPages);
    const safeCurrentPage = Math.min(Math.max(1, currentPage), safeTotalPages);
    const indexOfFirst = (safeCurrentPage - 1) * pageSize;
    const indexOfLast = Math.min(safeCurrentPage * pageSize, totalItems);
    const showPageNav = safeTotalPages > 1;
    const pageNumbers = getTablePageNumbers(safeCurrentPage, safeTotalPages);

    return (
        <nav className="orders-table-pagination" aria-label={ariaLabel}>
            <div className="orders-table-pagination__left">
                {showPageNav ? (
                    <div className="orders-table-pagination__legacy-nav pagination-container">
                        <button
                            type="button"
                            className="pagination-button"
                            onClick={() => onPageChange(safeCurrentPage - 1)}
                            disabled={safeCurrentPage <= 1}
                        >
                            Previous
                        </button>
                        <div className="pagination-numbers">
                            {pageNumbers.map((pageNum) => (
                                <button
                                    key={pageNum}
                                    type="button"
                                    className={`pagination-number-button${
                                        safeCurrentPage === pageNum ? ' active' : ''
                                    }`}
                                    onClick={() => onPageChange(pageNum)}
                                    aria-label={`Page ${pageNum}`}
                                    aria-current={
                                        safeCurrentPage === pageNum ? 'page' : undefined
                                    }
                                >
                                    {pageNum}
                                </button>
                            ))}
                        </div>
                        <button
                            type="button"
                            className="pagination-button"
                            onClick={() => onPageChange(safeCurrentPage + 1)}
                            disabled={safeCurrentPage >= safeTotalPages}
                        >
                            Next
                        </button>
                    </div>
                ) : null}
                <span className="orders-table-pagination__range">
                    {indexOfFirst + 1}-{indexOfLast} of {totalItems} {itemLabel}
                </span>
            </div>
            <label className="orders-table-pagination__page-size">
                <span className="orders-table-pagination__page-size-label">Rows per page</span>
                <select
                    className="orders-table-pagination__page-size-select"
                    value={pageSize}
                    onChange={(e) => onPageSizeChange(Number(e.target.value))}
                    aria-label="Rows per page"
                >
                    {ORDERS_PAGE_SIZE_OPTIONS.map((size) => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </select>
            </label>
        </nav>
    );
}

export default OrdersTablePagination;
